import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsUUID } from 'class-validator';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { UserDto } from '../../user/dto/user.dto';
import { UserPublicInterface } from '../../user/interfaces/user-public.interface';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';
import { JobPhaseInterface } from '../../job-phase/interfaces/job-phase.interface';
import { JobPhasePaidInterface } from '../interfaces/job-phase-paid.interface';

@Exclude()
export class JobPhasePaidDto
  extends CommonEntityDto
  implements JobPhasePaidInterface
{
  @ApiProperty({
    title: 'Paid',
    type: 'boolean',
    description: 'The payment status the job phase was left in by this change.',
  })
  @IsBoolean()
  @Expose()
  paid!: boolean;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: () => UserDto,
    title: 'User',
    description: 'The user who changed the payment status.',
  })
  @Expose()
  user?: UserPublicInterface | undefined;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;

  @ApiPropertyOptional({
    type: () => JobPhaseDto,
    title: 'Job Phase',
    description: 'The job phase whose payment status changed.',
  })
  @Expose()
  jobPhase?: JobPhaseInterface | undefined;
}
